
























import { Component, Mixins, Prop } from 'vue-property-decorator';
import { AxTransparent } from '@/mixins';

@Component
export default class AxRowCenter extends Mixins(AxTransparent) {
  @Prop({ type: String, default: '10' })
  margin!: string;
}
